import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);

const initialState = () => {
	return {
		user: null,
		organization: null,
		dataSets: null,
		organizationUser: null,
		business: null,
		notification: null,
		appInformation: null,
		// Loaded from `account/paymentInformation` alongside appInformation.
		// Drives feature gating in the admin nav (e.g. Registrations + Conference
		// Products only show when isPaymentActive === true).
		paymentInformation: null,
	};
};

export default new Vuex.Store({
	state: initialState(),
	mutations: mutations,
	getters: getters,
	actions: actions,
});
